import { initFederation } from '@angular-architects/module-federation';

// content of main.ts is moved to bootstrap.ts as part of using module federation in sustainium-ui
initFederation({}, true)
  .catch((err) => console.error(err))
  .then((_) => import('./bootstrap'))
  .catch((err) => console.error(err));
